import { cn } from '../../lib/cn';

export default function Card({
  children,
  className,
  gradient = false,
  elevated = false,
  padding = 'md',
  ...props
}) {
  const paddingSizes = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  return (
    <div
      className={cn(
        'rounded-xl',
        gradient
          ? 'bg-gradient-to-b from-gray-50 to-white dark:from-gray-800 dark:to-gray-900'
          : 'bg-white dark:bg-gray-800',
        elevated
          ? 'shadow-[0_4px_16px_rgba(0,0,0,0.12)]'
          : 'shadow-[0_2px_8px_rgba(0,0,0,0.08)] dark:shadow-[0_2px_8px_rgba(0,0,0,0.3)]',
        'transition-shadow duration-200',
        paddingSizes[padding],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className, ...props }) {
  return (
    <div
      className={cn('mb-4', className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children, className, as: Component = 'h3', ...props }) {
  return (
    <Component
      className={cn('text-lg font-semibold text-gray-900 dark:text-white', className)}
      {...props}
    >
      {children}
    </Component>
  );
}

export function CardDescription({ children, className, ...props }) {
  return (
    <p
      className={cn('text-sm text-gray-500 dark:text-gray-400 mt-1', className)}
      {...props}
    >
      {children}
    </p>
  );
}

export function CardContent({ children, className, ...props }) {
  return (
    <div className={cn(className)} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className, ...props }) {
  return (
    <div
      className={cn('mt-6 flex items-center', className)}
      {...props}
    >
      {children}
    </div>
  );
}
